import { PropType } from 'vue';
import { mapGetters } from 'vuex';
import { Vue, Options } from 'vue-class-component';
import plantsClient from '@/core/services/plants';
import {
  PlantDetailDTO,
  RoomObjectType,
  AggregateCommandDTO,
  AggregateCommandType,
} from '@/../client-generator/generated-clients/plants';
import CommandGroup from './CommandGroup/CommandGroup.vue';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { FETCH_PLANT } from '../../../../core/utils/emitter-events';

@Options({
  name: 'CommandsGroups',
  emits: ['add-object', 'add-structure', 'update-list'],
  props: {
    currentPlant: {
      type: Object as PropType<PlantDetailDTO>,
      required: false,
    },
  },
  components: { CommandGroup },
  computed: {
    ...mapGetters('UI', [
      'commandsAndGroupsAddGroupEnabled',
      'commandsAndGroupsGroupActionsEnabled',
    ]),
  },
})
export default class CommandsGroups extends Vue {
  commandsAndGroupsAddGroupEnabled!: boolean;
  commandsAndGroupsGroupActionsEnabled!: boolean;
  currentPlant!: PlantDetailDTO;
  activeTabIndex = 0;

  commands: AggregateCommandDTO[] = [];
  groups: AggregateCommandDTO[] = [];

  AggregateCommandType = AggregateCommandType;

  get backLink() {
    return {
      name: 'page-plant-dashboard',
      params: this.$route.params,
    };
  }

  mounted() {
    this.activeTabIndex = parseInt(
      sessionStorage.getItem(`${this.$route.name?.toString()}-selected-tab`) ??
        '0'
    );
    this.fetchData();
  }

  async fetchData() {
    this.$store.dispatch(SET_APP_LOADING, true);

    try {
      const result = await plantsClient.aggregateCommandsAll(
        this.currentPlant.desktopId as number
      );

      this.commands = result.filter(
        (r) => r.type === AggregateCommandType.General
      );

      this.commands.forEach(c => {
        if (c.id?.startsWith('__')){
          var name = this.$t('AppResource.GeneralCommand')
          if (c.roomObjectType == RoomObjectType.Light){
            c.name = `${name} ${this.$t('AppResource.Lights')}`
          }
          if (c.roomObjectType == RoomObjectType.Shutter){
            c.name = `${name} ${this.$t('AppResource.Shutters')}`
          }
        }
      })
      this.groups = result.filter((r) => r.type === AggregateCommandType.Group);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  handleEditCommandGroup(commandGroup: AggregateCommandDTO) {
    this.$router.push({
      name: 'page-command-wizard',
      params: { id: commandGroup.id as string },
      query: { aggregateCmdType: commandGroup.type?.toString() },
    });
  }

  handleCreateGroup(
    type: AggregateCommandType,
    roomObjectType?: RoomObjectType
  ) {
    this.$router.push({
      name: 'page-command-wizard',
      query: {
        aggregateCmdType: type.toString(),
        roomObjectType: roomObjectType,
      },
    });
  }

  async handleDeleteCommandGroup(commandGroup: AggregateCommandDTO) {
    if (!commandGroup.id) return;
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      await plantsClient.aggregateCommandsDELETE(
        this.currentPlant.desktopId as number,
        commandGroup.id
      );

      this.$emitter.emit(FETCH_PLANT);
      await this.fetchData();
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 3000,
      });
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  tabChanged(event: any) {
    sessionStorage.setItem(
      `${this.$route.name?.toString()}-selected-tab`,
      event.index.toString()
    );
  }
}
